import { AxiosPromise } from "axios";
import { IIdentityDocument } from "../../../shared/models/identity.model";
import ApiClient from "../../../configs/axios.config";
import { ISingleIdentityRequest, IUpdateIdentityRequest, IUpdateIdentityResponse } from "./identity.interfaces";

interface IGetDocumentsResponse {
  identityDocuments: IIdentityDocument[];
}
const IdentityApi = {
  routes: {
    identities: "/v1/identity-documents",
  },
  methods: {
    getDocuments: (): AxiosPromise<IGetDocumentsResponse> => {
      return ApiClient.get(IdentityApi.routes.identities);
    },

    createIdentity: (users: ISingleIdentityRequest[]): AxiosPromise<IIdentityDocument> => {
      return ApiClient.post(IdentityApi.routes.identities, users.length === 1 ? users[0] : users);
    },

    updateIdentity: (urn: string, values: IUpdateIdentityRequest): AxiosPromise<IUpdateIdentityResponse> => {
      return ApiClient.put(IdentityApi.routes.identities, {
        urn,
        ...values,
      });
    },

    deleteIdentity: (urn: string): AxiosPromise<IIdentityDocument> => {
      return ApiClient.delete(`${IdentityApi.routes.identities}`, {
        params: { urn },
      });
    },
    // getSingleIdentity: (urn: string): AxiosPromise<IIdentityDocument> => {
    //   return ApiClient.get(IdentityApi.routes.identities, {
    //     params: { urn },
    //   });
    // },
    getSingleIdentity: (urn: string): AxiosPromise<IIdentityDocument> => {
      return ApiClient.post(`${IdentityApi.routes.identities}/urn`, { urn });
    },
  },
};

export default IdentityApi;
